import {useUpmPlant} from '@hconnect/upm'
import {Loading} from '@hm/fundamental'

import {UpdateInstallationModalTabs} from './UpdateInstallationModalTabs'

import {useKilns} from '@refra/modules/common/providers'
import type {Refractory} from '@refra/modules/refra-catalog/types'
import {useMaterialInstallationDetailsQuery} from '@refra/modules/refra-planning/hooks/queries'
import type {MaterialInstallation} from '@refra/modules/refra-planning/types'
import {useUrlParam} from '@refra/modules/routing/hooks'

interface UpdateInstallationModalProps {
  min: number
  max: number
  shutdownId: number
  interventionDate: string
  materialInstallation: MaterialInstallation
  assignedRefractory: Refractory
  isReadOnly?: boolean
}

export const UpdateInstallationModal: React.FC<UpdateInstallationModalProps> = ({
  min,
  max,
  materialInstallation,
  shutdownId,
  interventionDate,
  assignedRefractory,
  isReadOnly = false
}) => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})

  const {selectedKiln} = useKilns()

  const {data: materialInstallationDetails} = useMaterialInstallationDetailsQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId,
    shutdownId,
    installationId: materialInstallation.id
  })

  if (!materialInstallationDetails) return <Loading size="large" />

  return (
    <UpdateInstallationModalTabs
      min={min}
      max={max}
      materialInstallationDetails={materialInstallationDetails}
      assignedRefractory={assignedRefractory}
      shutdownId={shutdownId}
      interventionDate={interventionDate}
      isReadOnly={isReadOnly}
    />
  )
}
